import styled from "styled-components";

// Reuse the same Card structure as assets TopHoldings
export const Card = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #e9eaeb;
  border-radius: 12px;
  box-shadow: 0px 1px 2px rgba(10, 13, 18, 0.05);
  background: #fff;
  width: 100%;
  overflow: hidden;
`;

export const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 20px;
  background: #ffffff;
  border-bottom: 1px solid #e9eaeb;

  a {
    font-family: "Geist", sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    color: #535862;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
    &:active {
      opacity: 0.6;
    }
  }
`;

export const CardContent = styled.div`
  background: #fff;
`;

/* Table cells specific to this accounts table */
export const AccountCell = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
`;

export const AccountLogo = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: block;
`;

export const PositionCell = styled.div`
  font-size: 14px;
  color: #344054;
`;

export const PriceCell = styled.div`
  font-size: 14px;
  color: #101828;
`;

export const ValueCell = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #101828;

  span {
    display: block;
    font-size: 12px;
    color: #667085;
  }
`;

export const ReturnCell = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: ${(props) => props.$color || "#101828"};
  display: flex;
  gap: 8px;
  align-items: center;
`;

export const ReturnPill = styled.div`
  display: inline-flex;
  padding: 2px 8px 2px 6px;
  align-items: center;
  gap: 4px;
  border-radius: 9999px;
  border: 1px solid ${(props) => (props.isPositive ? "#C5EDCE" : "#FECACA")};
  background: ${(props) => (props.isPositive ? "#F2FBF4" : "#FEF2F2")};
  color: ${(props) => (props.isPositive ? "#276E38" : "#A23B33")};
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
`;
